module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_0.33bc2b90.png";